export default {
    "name": "UpdateVehicleAttachment",
    "kind": "HoudiniMutation",
    "hash": "9b1f2083c68cd4ac35490cb1fe11cafc92ed5a7599ba6a2f484837fc205ba0a3",

    "raw": `mutation UpdateVehicleAttachment($input: VehicleAttachmentUpdate!) {
  updateVehicleAttachment(input: $input) {
    fileId: id
    rank
    public
    file {
      id
      name
      path: url
      type
      size
      mimeType: mimetype
      extension
      updated
      createdDate: created
    }
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateVehicleAttachment": {
                "type": "VehicleAttachment",
                "keyRaw": "updateVehicleAttachment(input: $input)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "fileId": {
                            "type": "UInt",
                            "keyRaw": "fileId",
                            "visible": true
                        },

                        "rank": {
                            "type": "Int",
                            "keyRaw": "rank",
                            "visible": true
                        },

                        "public": {
                            "type": "Boolean",
                            "keyRaw": "public",
                            "visible": true
                        },

                        "file": {
                            "type": "File",
                            "keyRaw": "file",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "path": {
                                        "type": "String",
                                        "keyRaw": "path",
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "FileType",
                                        "keyRaw": "type",
                                        "visible": true
                                    },

                                    "size": {
                                        "type": "Int",
                                        "keyRaw": "size",
                                        "visible": true
                                    },

                                    "mimeType": {
                                        "type": "String",
                                        "keyRaw": "mimeType",
                                        "visible": true
                                    },

                                    "extension": {
                                        "type": "String",
                                        "keyRaw": "extension",
                                        "visible": true
                                    },

                                    "updated": {
                                        "type": "Date",
                                        "keyRaw": "updated",
                                        "visible": true
                                    },

                                    "createdDate": {
                                        "type": "DateTime",
                                        "keyRaw": "createdDate",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "VehicleAttachmentUpdate"
        },

        "types": {
            "VehicleAttachmentUpdate": {
                "id": "UInt",
                "public": "Boolean",
                "rank": "Int"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=54fa0767b0c670a3453fe619bbe4ebbd46ec3a1913ae16e062cfe7121b93d526";